import { EvaluationReport } from "@/schema/console/evaluation-reports/EvaluationReport";
import EvaluationCard from "@/src/console/(auth)/_components/EvaluationReport/EvaluationCard";
import CollapsibleGoal from "@/src/console/(auth)/_components/EvaluationReport/SdgIndicatorCard/CollapsibleGoal";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

function SdgIndicatorCard() {
  const { control } = useFormContext<EvaluationReport>();
  const { t } = useTranslation();
  const { fields } = useFieldArray({
    control,
    name: "result_index.sdg_goal_results",
    keyName: "key",
  });
  return (
    <EvaluationCard cardTitle={t("sdgs-indicator-details")}>
      {fields.map((field, index) => (
        <CollapsibleGoal key={field.key} index={index} />
      ))}
    </EvaluationCard>
  );
}

export default SdgIndicatorCard;
